import React from 'react';
import {withStyles} from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Rating from "../assets/google_rating.png";
import Quote_Start from "../assets/quote_start.svg";
import Review_Shape from "../assets/review_shape.png";
import Potential from "../assets/potential.svg";
import Avatar from "../assets/avatar.png";

const muiTheme = createTheme({
    palette: {
        custom: {
            main: '#FFF'
        },
    },
    components: {
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    backgroundColor: "#009BB5",
                }
            }
        }
    }
});

const useStyles = theme => ({
    panel: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        background: '#280066',
    },
    content: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
        flexDirection: 'column',
        padding: '28px 28px',

        [theme.breakpoints.up('md')]: {
            width: '770px',
        }
    },
    potential: {
        display: 'flex',
        borderRadius: '25px',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginTop: '-280px',
        padding: '40px 30px 20px 30px',
        color: '#000',
        background: '#fff',

        [theme.breakpoints.up('md')]: {
            marginTop: '-220px',
        }
    },
    potentialPic: {
        padding: '0 0 10px 0',
    },
    reach: {
        fontFamily: 'Young Serif',
        fontSize: '2.6em',
        lineHeight: '1.1em',
    },
    inclusive: {
        padding: '20px 0',
        fontFamily: 'Montserrat',
        fontSize: '1.4em',
        lineHeight: '1.4em',

        [theme.breakpoints.up('md')]: {
            padding: '20px 120px',
        }
    },
    stampPanel: {
        display: 'flex',
    },
    avatar: {
        width: '65px',

        '& img': {
            width: '100%',
        }
    },
    founderPanel: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'left',
        padding: '0 0 0 15px',
    },
    founder: {
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.1em',
    },
    founderTitle: {
        fontFamily: 'Montserrat',
        fontSize: '1',
    },
    reviews: {
        display: 'flex',
        flexDirection: 'column',
        padding: '60px 0 0 0',

        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            padding: '40px 0 0 10px',
        },

        [theme.breakpoints.up('md')]: {
            padding: '40px 0 0 40px',
        },
    },
    quoteStart: {
        padding: '0 0 20px 6px',

        [theme.breakpoints.up('sm')]: {
            padding: '10px 15px 0 0',
        },
    },
    review: {
        display: 'flex',
        flexDirection: 'column',
        backgroundImage: 'url(' + Review_Shape + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'bottom right',

        [theme.breakpoints.up('sm')]: {
            padding: '10px 0 0 0',
        },
    },
    quote: {
        fontFamily: 'Montserrat',
        fontStyle: 'italic',
        fontSize: '1.4em',
        lineHeight: '1.4em',
        padding: '0 20px 0 0',
    },
    author: {
        fontFamily: 'Montserrat',
        fontSize: '1.1em',
        fontWeight: 'bold',
        lineHeight: '1.1em',
        padding: '30px 0 0 0',
    },
    title: {
        fontFamily: 'Montserrat',
        fontSize: '1',
    },
    google: {
        padding: '30px 0 0 0',

        [theme.breakpoints.up('sm')]: {
            padding: '0 0 0 30px',
        },
    },
});

class ReviewPanel extends React.PureComponent {
    render() {
        function RenderReview() {

            function getRandomIntInclusive(min, max) {
                min = Math.ceil(min); // Ensure min is an integer
                max = Math.floor(max); // Ensure max is an integer
                return Math.floor(Math.random() * (max - min + 1)) + min; // The maximum is inclusive and the minimum is inclusive
            }

            const reviews = JSON.parse('[' +
                '{"quote":"Matt has been a professional and reliable Service Provider. We appreciate his commitment to inclusive fitness and collaboration with our team.", "author":"Support Services", "title":"WeFlex"}, ' +
                '{"quote":"Matt has been providing fitness sessions for my son\'s basketball team. The kids are 10 years old and very hard to engage sometimes, but Matt\'s enthusiasm really motivated the kids and their fitness really levelled up over the term. Amazing!", "author":"Sara O\'Brien", "title":"Basketball Mum"}]');
            var nReview = getRandomIntInclusive(0, reviews.length-1);

            return (
                <div className={classes.review}>
                    <div className={classes.quote}>“{reviews[nReview].quote}”</div>
                    <div className={classes.author}>{reviews[nReview].author}</div>
                    <div className={classes.title}>{reviews[nReview].title}</div>
                </div>
            )
        }

        const { classes } = this.props;

        return (
            <ThemeProvider theme={muiTheme}>

                <div className={classes.panel}>
                    <div className={classes.content}>
                        <div className={classes.potential}>
                            <div className={classes.potentialPic}><img src={Potential} alt={"Potential"} /></div>
                            <div className={classes.reach}>Reach Your Potential</div>
                            <div className={classes.inclusive}>Regardless of age, ability, or physical condition, with inclusive, all-ability based exercise.</div>

                            <div className={classes.stampPanel}>
                                <div className={classes.avatar}><img src={Avatar} alt={"Avatar"} /></div>
                                <div className={classes.founderPanel}>
                                    <div className={classes.founder}>Matt Allbeury</div>
                                    <div className={classes.founderTitle}>Founder and Trainer</div>
                                </div>
                            </div>
                        </div>

                        <div className={classes.reviews}>
                            <div className={classes.quoteStart}><img src={Quote_Start} alt={"Quote"} /></div>
                            <RenderReview />
                            <div className={classes.google}><a href="https://www.google.com/search?q=dragon+community+gym&rlz=1C5OZZY_enAU1183AU1183&oq=dragon+&gs_lcrp=EgZjaHJvbWUqBggBECMYJzIHCAAQABiPAjIGCAEQIxgnMg8IAhAuGEMYsQMYgAQYigUyDQgDEAAYkQIYgAQYigUyDQgEEAAYkQIYgAQYigUyBggFEEUYPDIGCAYQRRg8MgYIBxBFGDzSAQgzMjg3ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8#mpd=~13905088347970202346/customers/reviews"><img src={Rating} alt={"Google Rating"}/></a></div>
                        </div>
                    </div>
                </div>

            </ThemeProvider>
        )
    }
}

export default withStyles(useStyles)(ReviewPanel)